var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"id":"groups-list","title":_vm.$root.translate('My Groups'),"is-root":true,"status":_vm.page_status,"waiting":_vm.waiting},on:{"statused":_vm.statused}},[_c('base-groups-list',{attrs:{"user":{ id: _vm.profile_id, _global: true }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }